<style lang="scss">
</style>

<template>
    <div class="search-wrap">
        <aside class='search-btn'>
            <ButtonGroup>
                <Button size='large'  v-for="(item,index) in btnsearch" :key="index" :type="formData.EQ_status===item.value?'primary':'default'" @click="handleBtn('EQ_status',item.value)">{{item.label}}</Button>
            </ButtonGroup>
        </aside>
        <article class="search-main clearfix">
            <div class="pull-left">
                <Button type="primary" @click="handleModal('add')" icon="md-add">添加</Button>
                <Button type="success" @click="handleModal('upload')">导入</Button>
                <Dropdown trigger="click">
                    <Button>
                        更多操作<Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem class="splitline" @click.native="handleModal('active')">批量激活</DropdownItem>
                        <DropdownItem @click.native="handleModal('cancel')">批量取消</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
            <div class="pull-right">
                <Form :label-width="50" inline>
                    <FormItem label='ERPSKU'>
                        <Input clearable v-model.trim="formData.CN_erpSku"/>
                    </FormItem>
                    <FormItem label='Seller SKU'>
                        <Input clearable v-model.trim="formData.EQ_sellerSku"/>
                    </FormItem>
                    <FormItem label='项目'>
                        <Select v-model="formData.EQ_lineId" filterable clearable>
                            <Option v-for="item in getNewProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label-width="1">
                        <Button type="primary" @click="update" icon="ios-search">搜索</Button>
                        <Button @click="reset" icon='md-refresh'>重置</Button>
                        <Button type="text" @click="isOpen=!isOpen">更多搜索<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                    </FormItem>
                </Form>
            </div>
        </article>
        <transition name='slide-both'>
            <Form class="search-other" :label-width="80" inline v-show="isOpen">
                <FormItem label='店铺'>
                    <Select v-model="formData.EQ_accountId" filterable clearable>
                        <Option v-for="item in getNewAccountIdList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem label='锁定仓库'>
                    <Select v-model="formData.EQ_orgWarehouseId" filterable clearable>
                        <Option v-for="item in getChangeWarehouse" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        <!-- <Option v-for="item in warehouses" :value="item.id" :key="item.id">{{ item.title }}({{ item.code }})</Option> -->
                    </Select>
                </FormItem>
                 <FormItem label='起至日期'>
                    <DatePicker v-model="formData.BT_beginDate" type="daterange"  placeholder="Select date"></DatePicker>
                </FormItem>
                 <FormItem label='状态'>
                    <Select v-model="formData.EQ_status" filterable clearable>
                        <Option v-for="item in btnsearch" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem label='处理结果'>
                    <Select v-model="formData.EQ_dealStatus" filterable clearable>
                        <Option v-for="item in dealStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem label='ID'>
                   <Input clearable v-model.trim="formData.EQ_id"/>
                </FormItem>
               
            </Form>
        </transition>
    
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {

    data() {
        return {
            isOpen: false,
            btnsearch: [{
                value: 'ACTIVATE',
                label: "激活"
            }, {
                value: 'DRAFT',
                label: "草稿"
            }, {
                value: 'CANCEL',
                label: "取消"
            }, {
                value: '',
                label: "不限"
            },],
            dealStatus: [{
                value: '',
                label: "不限"
            }, {
                value: '0',
                label: "待处理"
            }, {
                value: '1',
                label: "已处理"
            }, {
                value: '9',
                label: "异常"
            }],
            formData: {
                CN_erpSku: '',
                EQ_sellerSku: '',
                EQ_accountId: '',
                EQ_lineId: '',
                EQ_orgWarehouseId: '',
                BT_beginDate: '',
                EQ_status: 'ACTIVATE',
                EQ_dealStatus: '',
            },
        };
    },
    mounted() {
        this.update();
    },
    computed: {
        // ...mapState('boss',['products', 'accounts']),
        ...mapGetters('boss', ['warehouses']),
        ...mapGetters('diction',['getNewProductList','getNewAccountIdList']),

        getChangeWarehouse(){
            return this.warehouses.map(item=>{
                return {
                    value:item.id,
                    label:item.title +' ('+ item.code +')' 
                }
            })
        },
        propsData(){
            return [
                {label:'ERPSKU',key:'CN_erpSku'},
                {label:'Seller SKU',key:'EQ_sellerSku'},
                {label:this.$t('global.common.line',{defaultValue:'项目'}),key:'EQ_lineId',tag:'Select',value:this.getNewProductList},
                {label:this.$t('global.common.channel',{defaultValue:'店铺'}),key:'EQ_accountId',tag:'Select',value:this.getNewAccountIdList},
                {label:'锁定仓库',key:'EQ_orgWarehouseId',tag:'Select',value:this.getChangeWarehouse},
                {label:'起至日期',key:'BT_beginDate'},
                {label:'状态',key:'EQ_status',tag:'Select',value:this.btnsearch},
                {label:'处理结果',key:'EQ_dealStatus',tag:'Select',value:this.dealStatus},
                {label:'ID',key:'EQ_id'},
            ]
        },
        
    },
    methods: {
        handleModal(type, id) {
            this.$parent.handleOperates(id, type);
        },
        handleBtn(key, val) {
            this.$set(this.formData, key, val);
            this.update();
        },
        update() {
            const formdata = { ...this.formData }, beginDate = formdata.BT_beginDate;
            if (beginDate) {
                formdata.BT_beginDate = beginDate[0] ? this.handleDateFormat(beginDate[0], 'yyyy-mm-dd') + ' ~ ' + this.handleDateFormat(beginDate[1], 'yyyy-mm-dd') : '';
            }
            this.$emit('on-update', { search: formdata, page: 1 });
        },
        reset() {
            this.formData = {
                CN_erpSku: '',
                EQ_sellersku: '',
                EQ_accountId: '',
                EQ_lineId: '',
                EQ_orgWarehouseId: '',
                BT_beginDate: '',
                EQ_status: 'ACTIVATE',
                EQ_dealStatus: '',
            };
            this.$emit('on-update', {
                search: {
                    ...this.formData
                },
                page: 1
            });
        },
    },
};
</script>
